import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

function SeoTags({ title, keywords, description }) {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {keywords && <meta name="keywords" content={keywords} />}
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}

SeoTags.propTypes = {
  title: PropTypes.string,
  keywords: PropTypes.string,
  description: PropTypes.string,
};

SeoTags.defaultProps = {
  title: undefined,
  keywords: undefined,
  description: undefined,
};

export default SeoTags;



// WEBPACK FOOTER //
// ./src/components/shared/SeoTags/SeoTags.jsx